import axios from "axios";
import { getConfig } from "./configService";

let api = null;

export function getApi() {
  if (!api) {
    const config = getConfig();

    api = axios.create({
      baseURL: config.api_backend_route
    });
  }

  return api;
}